import { useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { isEmpty } from 'lodash'
import { useCallback } from 'react'

const useDeleteSuperEvents = (): [(ids: number[]) => Promise<void>, boolean] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<void>()

  const deleteSuperEvents = useCallback(
    async (ids: number[]) => {
      if (isEmpty(ids)) return

      return request({
        method: 'del',
        url: `/organizations/${organization.id}/super_events`,
        config: {
          queryStringParameters: {
            ids: ids.join(','),
          },
        },
      })
    },
    [organization.id, request],
  )

  return [deleteSuperEvents, status.loading]
}

export default useDeleteSuperEvents
